import type { StorageClass } from '@/service/gpu-instance/volume-type';

export const mockStorageClasses: StorageClass[] = [
  {
    id: 'sc-standard-ssd',
    name: 'standard-ssd',
    tier: 'standard-ssd',
    displayName: 'Standard SSD',
    description: 'Balanced performance for general workloads. Ideal for development, testing, and light production use.',
    iopsRange: { min: 3000, max: 16000 },
    throughputRange: { min: 125, max: 250 },
    pricePerGBMonth: 0.10,
    isDefault: true,
    provisioner: 'csi.trident.netapp.io',
    reclaimPolicy: 'Delete',
    allowVolumeExpansion: true,
    volumeBindingMode: 'WaitForFirstConsumer',
  },
  {
    id: 'sc-premium-ssd',
    name: 'premium-ssd',
    tier: 'premium-ssd',
    displayName: 'Premium SSD',
    description: 'High performance for production inference workloads. Consistent low latency and high IOPS.',
    iopsRange: { min: 5000, max: 64000 },
    throughputRange: { min: 250, max: 900 },
    pricePerGBMonth: 0.17,
    isDefault: false,
    provisioner: 'csi.trident.netapp.io',
    reclaimPolicy: 'Retain',
    allowVolumeExpansion: true,
    volumeBindingMode: 'WaitForFirstConsumer',
  },
  {
    id: 'sc-nvme',
    name: 'nvme-ultra',
    tier: 'nvme',
    displayName: 'NVMe Ultra',
    description: 'Ultra-high performance for ML training and real-time inference. Maximum IOPS and throughput.',
    iopsRange: { min: 100000, max: 400000 },
    throughputRange: { min: 1000, max: 4000 },
    pricePerGBMonth: 0.35,
    isDefault: false,
    provisioner: 'csi.trident.netapp.io',
    reclaimPolicy: 'Retain',
    allowVolumeExpansion: true,
    volumeBindingMode: 'Immediate',
  },
  {
    id: 'sc-archive-hdd',
    name: 'archive-hdd',
    tier: 'archive-hdd',
    displayName: 'Archive HDD',
    description: 'Cost-effective storage for cold data, backups, and archives. Lower performance, lowest cost.',
    iopsRange: { min: 500, max: 2000 },
    throughputRange: { min: 60, max: 160 },
    pricePerGBMonth: 0.02,
    isDefault: false,
    provisioner: 'csi.trident.netapp.io',
    reclaimPolicy: 'Delete',
    allowVolumeExpansion: true,
    volumeBindingMode: 'WaitForFirstConsumer',
  },
];

export const getStorageClassById = (id: string): StorageClass | undefined => {
  return mockStorageClasses.find((sc) => sc.id === id);
};

export const getStorageClassByTier = (tier: string): StorageClass | undefined => {
  return mockStorageClasses.find((sc) => sc.tier === tier);
};

export const getDefaultStorageClass = (): StorageClass => {
  return mockStorageClasses.find((sc) => sc.isDefault) || mockStorageClasses[0];
};
